import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import { ACCOMMODATION, BOOK_DATES } from 'graphql/queries/accommodations';

import { ACCOMMODATION_PRICES_FORMS_NUMBERS } from 'pages/create-accommodation/constants';

import { getReceivedAccommodationData } from 'utils/accommodations-and-activities/prepareReceivedAccommodationData';

import ConfirmContext from 'contexts/ConfirmContext';
import moment from 'moment';

const UpdateAccommodationWrapper = ({ children, businessOwner }) => {
  const { id } = useParams();
  const confirm = React.useContext(ConfirmContext);
  const history = useHistory();

  const { loading, error, data, refetch, networkStatus } = useQuery(
    ACCOMMODATION,
    {
      variables: {
        accommodationId: id,
        businessOwnerId:
          businessOwner.selectedBusinessOwner.ownerId ||
          businessOwner.selectedBusinessOwner.id
      },
      notifyOnNetworkStatusChange: true
    }
  );

  const bookDates = useQuery(BOOK_DATES, {
    variables: {
      accommodationId: id,
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id,
      startPeriod: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endPeriod: moment(moment().add(6, 'months'))
        .endOf('month')
        .format('YYYY-MM-DD')
    },
    notifyOnNetworkStatusChange: true
  });

  React.useEffect(() => {
    refetch();
    bookDates.refetch();
  }, []);

  const isCopy = () => {
    return window.location.href.search('/copy') >= 0;
  };

  if (
    loading ||
    bookDates.loading ||
    networkStatus === 4 ||
    bookDates.networkStatus === 4
  ) {
    return (
      <div style={{ height: '100%' }}>
        {React.cloneElement(children, {
          loading: true,
          isCopy: isCopy(),
          bookDates: []
        })}
      </div>
    );
  }

  if (error || !data.accommodations.length) {
    if (
      businessOwner &&
      businessOwner.selectedBusinessOwner.hasOwnProperty('id')
    ) {
      confirm({
        title: 'Accommodation does not exist!',
        confirmationText: 'Back'
      })
        .then(() => history.push('/accommodations-and-activities'))
        .catch(() => {});
    }

    return (
      <div style={{ height: '100%' }}>
        {React.cloneElement(children, {
          loading: false,
          isCopy: isCopy(),
          bookDates: []
        })}
      </div>
    );
  }

  const accommodation = data.accommodations[0];
  
  const initialData = getReceivedAccommodationData(accommodation);
  let pricesActiveSubTabNumber =
    ACCOMMODATION_PRICES_FORMS_NUMBERS.pricesFixedForm;

  if (accommodation.prices[0]?.participant?.participant) {
    pricesActiveSubTabNumber =
      ACCOMMODATION_PRICES_FORMS_NUMBERS.pricesCategoryForm;
  }

  if (accommodation.prices[0]?.day) {
    pricesActiveSubTabNumber =
      ACCOMMODATION_PRICES_FORMS_NUMBERS.pricesDailyForm;
  }
  
  // Determine base prices type for fallback tracking
  let basePricesType = 'pricesFixedForm';
  const firstPrice = accommodation.prices?.[0];

  if (firstPrice?.participant?.participant) {
    basePricesType = 'pricesCategoryForm';
  } else if (firstPrice?.day) {
    basePricesType = 'pricesDailyForm';
  }
  
  initialData['basePricesType'] = basePricesType;
  

  

  return (
    <div style={{ height: '100%' }}>
      {React.cloneElement(children, {
        data: initialData,
        pricesActiveSubTabNumber,
        loading: false,
        isCopy: isCopy(),
        bookDates: bookDates.data?.accommodations?.[0]?.bookedDates || [],
        existingFutureRatePlanIds: accommodation?.futurePrices?.map(fp => fp.ratePlan.id) || []
      })}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(UpdateAccommodationWrapper);
